import { render, staticRenderFns } from "./comment-viewpoint.vue?vue&type=template&id=1a7efde2&scoped=true&"
import script from "./comment-viewpoint.vue?vue&type=script&setup=true&lang=js&"
export * from "./comment-viewpoint.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./comment-viewpoint.vue?vue&type=style&index=0&id=1a7efde2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7efde2",
  null
  
)

export default component.exports